import axios from "axios"

export const loadEWStatus = () => {
  return axios.get("https://ew-registry.engaging.works")
}

export const loadEBStatus = () => {
  return axios.get("https://eb-registry.engaging.works")
}
